import { InvoicesPendingDueResponse } from "@/app/features/InvoiceBillingReminder/billingReminder.types";
import { ApiRoutes } from "../apiRoutes";
import { brGet } from "../brRequestWrapper";
import { useQuery } from "react-query";
import useExportToFile from "../../utils/useExportToFile";
import { FileType } from "../../constants/misc/FileType";

export interface InvoicesPendingDueRequest {
  pageSize: number,
  isCsv: boolean,
  cursor?: number
}

const { exportFile } = useExportToFile();

export const getInvoicesPendingDueCSV = async () => {
  const requestConfig = {
    headers: {
      "api-version": "2.0",
    },
  };
  const path = ApiRoutes.PendingDueInvoices;
  const request = `${path}?iscsv=${true}`;
  const response = await brGet(request, requestConfig);

  await exportFile("BillingReminder", response.data, FileType.Csv);
  return response.data;
};

export const useGetInvoicesPendingDueV2 = (request: InvoicesPendingDueRequest) => useQuery({
  queryKey: ["invoices-pending-due-v2", request.pageSize, request.isCsv, request.cursor],
  enabled: false,
  queryFn: async (): Promise<InvoicesPendingDueResponse> => {
    const requestConfig = {
      headers: {
        "api-version": "2.0",
      },
    };
    const route = `${ApiRoutes.PendingDueInvoices}?pageSize=${request.pageSize}&isCsv=${request.isCsv}` + (request.cursor ? `cursor=${request.cursor}`: '');

    try {
      const response = await brGet(
        route,
        requestConfig
      );
      return response.data;
    } catch (error: any) {
      // Return empty data for 400 errors (no data available)
      if (error.response?.status === 400) {
        return {
          items: [],
          pageSize: 10,
          totalCount: 0,
          hasMore: false
        };
      }
      // All other errors are handled by brRequestWrapper
      throw error;
    }
  }
})
